/** Vitrin şeridinin (`/games/showcase`) çizilecek kartları.
 *
 * Panelden seçilen oyunlar listenin başındadır (`manual_count`). Seçim varsa
 * hepsi çizilir, yoksa otomatik doldurmanın ilk `fallbackLimit` kartı: şerit
 * bu yüzden uçtan geniş bir limitle istenir. Eskiden istek sabit küçük bir
 * limitle yapılıyordu ve işaretlenen oyunların yalnızca ilk yedisi şeride
 * giriyordu (Betrun, 26.09.2026); otomatik şeridi de elli karta açmak popüler
 * şeridi boşaltırdı (örtüşen oyunlar oradan ayıklanır).
 */
export const featuredItems = (data, fallbackLimit) => {
  const items = Array.isArray(data?.items) ? data.items : [];
  const manual = Number(data?.manual_count) || 0;
  return manual > 0 ? items.slice(0, manual) : items.slice(0, fallbackLimit);
};

export default featuredItems;
